@if (ngControl?.control) {
    <mat-checkbox [formControl]="$any(ngControl!.control)" [attr.data-uiid]="dataUiid">
        {{ label }}
    </mat-checkbox>
} @else {
    <mat-checkbox [(ngModel)]="value" [attr.data-uiid]="dataUiid">
        {{ label }}
    </mat-checkbox>
}
